import { useState } from "react";
import { Container, Navbar } from "@postenbring/hedwig-react";
import { MenuMainContent } from "./menu-content";
import { MenuIconSection } from "./menu-icon-section";
import { Search } from "./search/search";
import { CloseIcon, SearchIcon } from "../../shared/icons";
import { Login } from "./login";

const Logo = ({ headerData, showSearchInput }) => (
    <Navbar.Logo
        asChild
        className="kp-header-logo"
        data-state={showSearchInput ? "hidden-on-search-open" : "visible"}
    >
        <a href={headerData.siteUrl} title={headerData.toFrontPage} />
    </Navbar.Logo>
);

export const HdsNavbar = ({ headerData, trackingUrl }) => {
    const [showSearchInput, setShowSearchInput] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);

    return (
        <>
            <Navbar
                className="kp-header"
                data-state={showSearchInput ? "search-open" : "search-closed"}
            >
                <Logo headerData={headerData} showSearchInput={showSearchInput} />

                {/* Temporary fix to show the divider links in the header until we get the switch in hds and can upgrade to hds 4, where the divider will be a separate component and not part of the main navigation anymore */}
                {headerData.divider && (
                    <Navbar.Navigation className="kp-header-switch kp-hidden-before-large">
                        <>
                            <Navbar.LinkItem
                                className={headerData.isInPrivateSection ? "active" : ""}
                                title={headerData.divider.privateSection.title}
                                href={headerData.divider.privateSection.url}
                            >
                                {headerData.divider.privateSection.title}
                            </Navbar.LinkItem>
                            <Navbar.LinkItem
                                className={!headerData.isInPrivateSection ? "active" : ""}
                                title={headerData.divider.businessSection.title}
                                href={headerData.divider.businessSection.url}
                            >
                                {headerData.divider.businessSection.title}
                            </Navbar.LinkItem>
                        </>
                    </Navbar.Navigation>
                )}
                <Navbar.Navigation className="kp-header-navbar">
                    {showSearchInput ? (
                        <>
                            <Search headerData={headerData} trackingUrl={trackingUrl} />
                            <Navbar.ButtonItem
                                className="kp-header-main-nav-item kp-header-search-close"
                                aria-expanded={showSearchInput}
                                onClick={() => setShowSearchInput(false)}
                            >
                                <CloseIcon />
                            </Navbar.ButtonItem>
                        </>
                    ) : (
                        <>
                            <Navbar.ButtonItem
                                title={headerData.searchButtonLabel}
                                className="kp-hidden-before-large"
                                onClick={() => setShowSearchInput(true)}
                            >
                                {headerData.searchButtonLabel}
                                <SearchIcon />
                            </Navbar.ButtonItem>
                            <Navbar.ButtonItem
                                className="kp-hidden-after-large kp-decorator-header-main-nav-item"
                                aria-expanded={showSearchInput}
                                title={headerData.searchButtonLabel}
                                onClick={() => {
                                    setShowSearchInput(true);
                                }}
                            >
                                <SearchIcon />
                            </Navbar.ButtonItem>
                        </>
                    )}
                    {headerData.loginLinks?.length > 0 && (
                        <Login
                            headerData={headerData}
                            showLoginModal={showLoginModal}
                            setShowLoginModal={setShowLoginModal}
                        />
                    )}
                    <Navbar.ExpandableMenu className="kp-header-menu">
                        <Navbar.ExpandableMenuTrigger
                            data-state={showSearchInput ? "hidden-on-search-open" : "visible"}
                            whenClosedText={headerData.menuLabel}
                            whenOpenText={headerData.closeMenuLabel}
                        />
                        <Navbar.ExpandableMenuContent>
                            <Container>
                                <MenuIconSection content={headerData.iconSection} />
                                <MenuMainContent mainContent={headerData.mainSections} />
                            </Container>
                        </Navbar.ExpandableMenuContent>
                    </Navbar.ExpandableMenu>
                </Navbar.Navigation>
            </Navbar>
            <div
                className="kp-header-overlay"
                data-state={showSearchInput || showLoginModal ? "active" : "closed"}
            />
        </>
    );
};
